import { Buffer } from 'buffer'

export const state = () => {
	return {
		levels: [],
		ttl_levels: null,
		cache_duration_levels: 1800000, // 30 minutes
		cache_key_levels: '',
		level: {},
		ttl_level: null,
		cache_duration_level: 1800000,
		cache_key_level: '',
	}
}

function isInCacheLevels(state, companyId) {
	if (state.cache_key_levels !== buildCacheKeyLevels(companyId)) {
		return false
	}
	if (state.ttl_levels === null || state.ttl_levels < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyLevels(companyId) {
	return 'company:' + companyId + ':levels'
}

function isInCacheLevel(state, companyId, levelId) {
	if (state.cache_key_level !== buildCacheKeyLevel(companyId, levelId)) {
		return false
	}
	if (state.ttl_level === null || state.ttl_level < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyLevel(companyId, levelId) {
	return `company:${companyId}:level:${levelId}`
}

export const actions = {
	async list({ state, commit }, { companyId, noCache = false }) {
		if (noCache !== true && isInCacheLevels(state, companyId)) {
			return state.levels
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/vip-tiers/levels/`)
			.then((res) => {
				commit('setLevels', { data: res, companyId })
				return res
			})
			.catch((err) => {
				commit('clearCacheLevels')
				throw err
			})
	},

	async retrieve({ state, commit }, { companyId, levelId }) {
		if (isInCacheLevel(state, companyId, levelId)) {
			return state.level
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/vip-tiers/levels/${levelId}/`)
			.then((res) => {
				commit('setLevel', { data: res, companyId, levelId })
				return res
			})
			.catch((err) => {
				commit('clearCacheLevel')
				throw err
			})
	},

	async create({ commit }, { companyId, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/vip-tiers/levels/`, {
				method: 'POST',
				body: data,
			})
			.then((res) => {
				commit('clearCacheLevel')
				commit('clearCacheLevels')
				commit('brandingVipLevels/invalidateCache', null, { root: true })
				return res
			})
			.catch((err) => {
				commit('clearCacheLevel')
				commit('clearCacheLevels')
				throw err
			})
	},

	async delete({ commit, dispatch }, { companyId, level }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/vip-tiers/levels/${level.id}/`, { method: 'DELETE' })
			.then((res) => {
				commit('invalidateCacheLevels')
				commit('invalidateCacheLevel')
				dispatch('list', { companyId })
				return res
			})
			.catch((err) => {
				commit('invalidateCacheLevels')
				commit('invalidateCacheLevel')
				commit('brandingVipLevels/invalidateCache', null, { root: true })
				dispatch('list', { companyId })
				throw err
			})
	},

	async partial_update({ dispatch, commit }, { companyId, level, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/vip-tiers/levels/${level.id}/`, {
				method: 'PATCH',
				body: data,
			})
			.then(async () => {
				commit('invalidateCacheLevels')
				commit('invalidateCacheLevel')
				return await dispatch('list', { companyId })
			})
			.catch((err) => {
				dispatch('retrieve', {
					companyId,
					levelId: level.id,
				})
				commit('invalidateCacheLevels')
				commit('invalidateCacheLevel')
				commit('brandingVipLevels/invalidateCache', null, { root: true })
				throw err
			})
	},

	async uploadIcon(_, { companyId, extension, file_type: fileType, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/vip-tiers/levels/signed_url/`, {
				params: { extension },
			})
			.then(async (res) => {
				await $fetch(res.signed_url, {
					method: 'PUT',
					body: Buffer.from(data.replace(/^data:\w+\/\w+;base64,/, ''), 'base64'),
					headers: { 'Content-Type': fileType },
				})

				return res.remote_url
			})
	},
}

export const mutations = {
	setLevels(state, { data, companyId }) {
		state.levels = data
		state.ttl_levels = Date.now() + state.cache_duration_levels
		state.cache_key_levels = buildCacheKeyLevels(companyId)
	},

	setLevel(state, { data, companyId, levelId }) {
		state.level = data
		state.ttl_level = Date.now() + state.cache_duration_level
		state.cache_key_level = buildCacheKeyLevel(companyId, levelId)
	},

	clearCacheLevels(state) {
		state.levels = []
		state.ttl_levels = null
		state.cache_key_levels = ''
	},

	clearCacheLevel(state) {
		state.level = {}
		state.ttl_level = null
		state.cache_key_level = ''
	},

	invalidateCacheLevels(state) {
		state.ttl_levels = null
	},

	invalidateCacheLevel(state) {
		state.ttl_level = null
	},
}
